var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      ref: "bundleContainer",
      class: ((_obj = {}),
      (_obj[_vm.$style.bundle] = true),
      (_obj[_vm.$style.bundleAnimated] = _vm.animated),
      _obj),
      attrs: {
        "enter-class": _vm.$style.bundleItemEnter,
        "leave-to-class": _vm.$style.bundleItemLeaveTo,
        "leave-active-class": _vm.$style.bundleItemLeaveActive,
        tag: "div"
      }
    },
    _vm._l(_vm.sortedItemImages, function(image) {
      var _obj
      return _c("img", {
        key: image.key,
        class: ((_obj = {}),
        (_obj[_vm.$style.bundleItem] = true),
        (_obj[_vm.$style.burgerWrapper] = image.isBurgerWrapper),
        _obj),
        style: image.style,
        attrs: { src: image.url, alt: "" }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/Preview/BurgerPreview.vue?vue&type=template&id=6edc3369&
// module id = null
// module chunks = 